// Reason: TTLs from offline-pwa-phase-1.md §3.2. Numbers are in ms.
// Names mirror the entity / view they gate so call sites are grep-able.
export const DAILY_BRIEFING_TTL_MS = 5 * 60 * 1000;      // 5 min
export const TOPIC_DIGEST_TTL_MS = 10 * 60 * 1000;       // 10 min
// Reason: both briefing views (/briefing topics + /daily) bundle volatile
// read-state (unread_count / per-item is_read) into their cached payload.
// TTL=0 forces cache-then-revalidate on every mount so marking read (here, on
// the topic page, or elsewhere) self-heals on return instead of replaying a
// stale snapshot. ETag makes the unchanged case a cheap 304.
export const BRIEFING_TTL_MS = 0;                         // always revalidate
export const ARTICLE_TTL_MS = 60 * 60 * 1000;            // 60 min
export const HIGHLIGHTS_TTL_MS = 30 * 1000;              // 30 s
export const ARTICLE_LIST_TTL_MS = 60 * 1000;            // 60 s (dashboard)
export const RECENT_OPENED_LIMIT = 50;                    // Spec §3.5 step 3 union
